import configureMockStore from "redux-mock-store";
import thunk from "redux-thunk";

const mockStore = configureMockStore([thunk]);

import * as actions from "../containers/duck";

describe("handleQuery", () => {
  it("only accepts an object as params", async () => {
    const store = mockStore();
    const params = undefined;
    const response = await store.dispatch(actions.handleQuery(params));
    expect(response).toEqual(
      "Error: handleQuery on pop: Params is not an object"
    );
  });
});
